import { Feed, FeedData, FeedDataItem, ProductRecommendationWeights } from '@models/feed';
import { apiClient } from '.';
import { ProductCollection } from '@models/productCollection';

export const getProductRootCategories = async () => {
  return await apiClient.get<Feed<FeedData<FeedDataItem>>>(`/admin/v2/feed/product-root-categories`);
};

export const updateProductRootCategories = async (formData: FormData) => {
  return apiClient.put<Feed<FeedData<FeedDataItem>>>(`/admin/v2/feed/product-root-categories`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getProductRecommendationWeights = async () => {
  return apiClient.get<ProductRecommendationWeights>(`/admin/v2/feed/main-feed-v2/product-recommendation-weights`);
};

export const updateProductRecommendationWeights = async (body: ProductRecommendationWeights) => {
  return apiClient.put<ProductRecommendationWeights>(
    `/admin/v2/feed/main-feed-v2/product-recommendation-weights`,
    body,
  );
};

export const getMainFeedV2Banners = async () => {
  return apiClient.get<FeedData<FeedDataItem>>(`/admin/v2/feed/main-feed-v2/banners`);
};

export const updateMainFeedV2Banners = async (formData: FormData) => {
  return apiClient.put(`/admin/v2/feed/main-feed-v2/banners`, formData, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getProductCollectionFeed = async (): Promise<{ data: Feed<ProductCollection> }> => {
  return await apiClient.get(`/admin/v2/feed/product-collection-feed`);
};

export const updateProductCollectionFeed = async (formData: FormData): Promise<{ data: Feed<ProductCollection> }> => {
  return await apiClient.put(`/admin/v2/feed/product-collection-feed`, formData, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/** shortcut-v2 feed: Feed > data[0] (FeedData) > data (tabs: FeedDataItem[]) */
export type ShortcutV2Feed = Feed<FeedData<FeedDataItem>>;

export const getShortcutV2 = async () => {
  return await apiClient.get<ShortcutV2Feed>(`/admin/v2/feed/shortcut-v2`);
};

export const updateShortcutV2 = async (formData: FormData) => {
  return await apiClient.put<ShortcutV2Feed>(`/admin/v2/feed/shortcut-v2`, formData, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export type MainFeedV2Config = any;

export const getMainFeedV2Config = async () => {
  return await apiClient.get<MainFeedV2Config>(`/admin/v2/feed/config`);
};

export const updateMainFeedV2Config = async (body: MainFeedV2Config) => {
  return await apiClient.put<MainFeedV2Config>(`/admin/v2/feed/config`, body);
};

export const getTimeSalesFeed = async () => {
  return await apiClient.get<Feed<FeedData<FeedDataItem>>>(`/admin/v2/feed/time-sales`);
};

export const updateTimeSalesFeed = async (body: {
  products: Array<{ _id: string; type: string }>;
  subCarousels: Array<{
    title: string;
    active: boolean;
    autoplay?: boolean;
    delay?: number;
    productIds: string[];
  }>;
}) => {
  return await apiClient.put<Feed<FeedData<FeedDataItem>>>(`/admin/v2/feed/time-sales`, body);
};

export const getTimeSalesConfig = async () => {
  return await apiClient.get<any>(`/admin/v2/feed/time-sales-config`);
};

export const updateTimeSalesConfig = async (formData: FormData) => {
  return await apiClient.put<any>(`/admin/v2/feed/time-sales-config`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
